import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";
import {OutgoingsReportModel} from "./outgoings-report.model";

@Component({
    selector: "wbo-outgoings-report",
    templateUrl: "./outgoings-report.component.html",
    providers: [provideReportModel(OutgoingsReportModel)]
})
export class OutgoingsReportComponent extends AbstractReportPage {

    constructor(public model: OutgoingsReportModel) {
        super();
    }
}
